import React, { useContext } from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { breakpoints, color } from "../../utils/style"
import ButtonLink from "../shared/ButtonLink"
import { LogoutButton } from "../Auth/Auth"
import StoreContext from "../shared/Context/StoreContext"

const HeaderContacts = styled("div")`
  flex-basis: 70%;
  text-align: right;
  padding-top: 7px;
  .header-search-wrapper {
    display: inline-block;
  }
  .header-contact-group {
    display: flex;
    float: right;
    .button {
      padding: 9px 20px 5px;
      margin-left: 10px;
      font-size: 14px;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .green-button {
      width: 205px;
      height: 46px;
      margin: 0;
      span {
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        vertical-align: baseline;
      }
    }
    .register-button {
      padding: 0;
      height: 48px;
      width: 171px;
      text-align: center;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-top: 2px;
        line-height: 22px;
      }
      &:hover,
      &:active {
        padding: 10px 23px 6px;
      }
    }
    .logout-button {
      height: auto;
      padding: 14px 23px;
      width: 178px;
      text-align: center;
      svg {
        margin-left: 7px;
        vertical-align: top !important;
      }
    }
  }
  .header-image-wrap,
  .button {
    display: inline-block;
    vertical-align: top;
    margin-top: 10px;
  }
  .header-image-wrap .gatsby-image-wrapper {
    border-radius: 100%;
  }
  .popup-content {
    text-align: center;
  }

  @media (max-width: ${breakpoints.lg}) {
    flex-basis: 70%;
    .header-contact-group {
      .button {
        margin: 0 0 0 10px;
      }
      .red-button {
        margin-right: 10px;
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    display: none;
    .header-contact-group {
      display: none;
    }
    .header-search-wrapper {
      display: block;
      width: 100%;
      position: relative;
      .close-menu {
        position: absolute;
        top: 22px;
        right: 5px;
        background: none;
      }
    }
  }
`

export default ({ children }) => {
  const value = useContext(StoreContext)
  const username = value.username
  return (
    <HeaderContacts id="header-contacts-menu" className="header-contacts-menu">
      <div className="header-contact-group">
        <ButtonLink
          to={process.env.LINE_ID}
          text={process.env.LINE_ID_TEXT}
          external={true}
          className="button transparent-button-gold"
          iconName="line"
          iconSize={24}
          iconColor={color.gold}
          ariaText="Line"
          iconLeft={true}
        />

        <ButtonLink
          to={`tel:${process.env.PHONE_TO_CALL}`}
          external={true}
          ariaText="Call"
          className="button transparent-button-gold phone-cell-button"
          iconColor={color.gold}
          text={process.env.PHONE_TO_DISPLAY}
          iconName="call-answer"
          iconLeft={true}
          iconSize={20}
        />

        {children}

        {username ? (
          <LogoutButton />
        ) : (
          <Link className="button red-button" to="/register/" text="Register">
            <span>สมัครสมาชิก</span>
          </Link>
        )}
      </div>
    </HeaderContacts>
  )
}
